import {
  useJsonForms,
  withJsonFormsCellProps,
  withJsonFormsControlProps,
} from "@jsonforms/react";
import {
  ControlProps,
  rankWith,
  isDescriptionHidden,
  isDateControl,
  CellProps,
  WithClassname,
} from "@jsonforms/core";
import React, { useEffect, useState, useRef } from "react";
import { Input } from "../../../../../../shadcn/components/ui/input";

export const TextFieldTypeRenderer = (props: ControlProps) => {
  const { data, handleChange, path, schema, visible, uischema, errors } = props;
  const ctx = useJsonForms();
  const title = schema?.title;
  const inputFieldClassName = uischema?.options?.inputFieldClassName;
  const outerContainerClassName = uischema?.options?.outerContainerClassName;
  const additionalData = uischema?.options?.additionalData;
  const [value, setValue] = React.useState<any>(data === undefined ? "" : data);
  const [customError, setCustomError] = useState("");
  const positionRef = useRef<HTMLInputElement>(null);
  const show = uischema?.options?.show;
  const disableClearValue = additionalData?.disableClearValue;

  useEffect(() => {
    if (disableClearValue === true) return;
    if (show === false) {
      handleChange(path, "");
      setValue("");
    }
  }, [show]);

  useEffect(() => {
    const errorData = ctx?.core?.errors;
    let flag = false;
    errorData?.forEach((error: any) => {
      if (error?.instancePath === "/" + path) {
        setCustomError(error?.message);
        flag = true;
      } else if (
        error?.instancePath === "" &&
        error?.params?.missingProperty === path
      ) {
        setCustomError("Required Field");
        flag = true;
      }
    });

    if (!flag) setCustomError("");
    else {
      if (positionRef.current) {
        positionRef.current.scrollIntoView({
          behavior: "smooth",
        });
      }
    }
  }, [ctx?.core?.errors]);

  return visible && show ? (
    <>
      <div
        ref={positionRef}
        className={` relative w-full ${outerContainerClassName}`}
      >
        <Input
          id="name"
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
            handleChange(path, e.target.value);
          }}
          className={`bg-white  py-4 peer pl-4 autofill:bg-white focus:border-brand-orange pb-[6px] h-[50px]  outline-none  border  w-full   font-openSans font-normal text-web-body-sm leading-4 text-brand-textLightGrey ${inputFieldClassName}`}
        />
        <label
          htmlFor="name"
          className={`absolute font-openSans font-normal text-web-body-sm leading-3 mid:text-web-body-lg mid:leading-5 ${
            !ctx?.core?.data?.[path]
              ? "text-brand-borderGrey"
              : "text-transparent"
          } left-4 top-4 pointer-events-none transition-all duration-300 peer-placeholder-shown:top-1.5 peer-placeholder-shown:text-gray-400 peer-placeholder-shown:text-[10px] peer-focus:top-1.5 peer-focus:text-[10px] peer-focus:leading-[13px] peer-focus:text-brand-orange peer-valid:top-1.5 peer-valid:text-[10px] peer-valid:leading-[13px] peer-valid:text-brand-borderGrey`}
        >
          {title}
        </label>
        {customError && (
          <label
            htmlFor="name"
            className={"text-brand-textRed text-web-body-sm ml-2"}
          >
            {customError}
          </label>
        )}
      </div>
    </>
  ) : (
    <></>
  );
};

export default withJsonFormsControlProps(TextFieldTypeRenderer);
